import React from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ACTIONS from '../redux/actions/Page';
import * as UI_ACTIONS from '../redux/actions/UI';

import Content from '../components/Content';
import NewFooter from '../components/NewFooter';

function mapStateToProps(state) {
  return {
    entry: state.Page.entry,
    landing: state.Page.landing,
    article: state.Page.article,
    loading: state.Page.loading,
    loaded: state.Page.loaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchPage: bindActionCreators(ACTIONS.getPage, dispatch),
    fetchLandingPage: bindActionCreators(ACTIONS.getLandingPage, dispatch),
    fetchArticle: bindActionCreators(ACTIONS.getArticle, dispatch),
    clearArticle: bindActionCreators(ACTIONS.clearArticle, dispatch),
    siteReady: bindActionCreators(UI_ACTIONS.siteReady, dispatch),
    showNav: bindActionCreators(UI_ACTIONS.showNav, dispatch),
  };
}

class Information extends React.Component {
  scrollDist = 300;

  constructor(props) {
    super(props);
    this.state = {
      opacity: 1,
    };
  }

  componentDidMount() {
    this.props.fetchPage(this.props.location.pathname);
    this.props.fetchLandingPage();

    window.scrollTo(0, 0);
    this.props.siteReady();
    this.props.showNav();
    //window.addEventListener('scroll',this.handleScroll)
  }

  handleScroll = () => {
    const scrolled = Math.floor(window.scrollY / this.scrollDist);
    const introsHeight = window.innerHeight;

    if (window.scrollY > introsHeight) {
      const diff = window.scrollY - introsHeight;
      let percentage = 100 - (diff / window.innerHeight) * 100;
      let opacity = Math.round(percentage) / 100;

      this.setState({
        opacity: opacity,
      });
    }

    //if(scrolled < 3) {
    let index = 0;
    for (var ref in this.refs) {
      if (this.refs.hasOwnProperty(ref)) {
        const el = this.refs[ref];

        if (index > 0) {
          if (index <= scrolled) {
            if (!el.classList.contains('is-active')) {
              el.classList.add('is-active');
            }
          } else {
            if (el.classList.contains('is-active')) {
              el.classList.remove('is-active');
            }
          }
        }

        index++;
      }
    }

    //}
  };

  render() {
    let { entry, landing } = this.props;
    if (!entry || !landing) return null;

    console.log('info', entry, landing);

    return (
      <div
        className="Project Project--page"
        data-project={entry.id}
        ref="project"
      >
        {entry.pageTitle && (
          <Helmet>
            <title>{entry.pageTitle}</title>
            <meta name="description" content={entry.metaDesc} />
          </Helmet>
        )}
        <div className="Project-head">
          {' '}
          <h1> {entry.title}</h1>
        </div>

        {/*<div className="Project-intros" ref="intros" style={{ opacity: this.state.opacity}}>
					{entry.intros.map((intro,key) => {
						//let cls = key == 0 ? 'is-active' : null
						return <div className="Project-intro" key={key} ref={'intro--'+key}>
							<Content modifier="information" html={`<p>${intro}</p>`}/>
						</div>
					})}
				</div>*/}

        <div className="Project-body">
          <div className="Project-text">
            <Content modifier="information" html={entry.aboutText} />
            {/* <Signup listId={listId} /> */}
          </div>
          {/* <div className="contactButton">
            <a href={`mailto:${entry.contactEmail}`} className="button">
              {entry.contactLabel || 'Contact Us'}
            </a>
          </div> */}
          <div className="Project-logos">
            {entry.logos &&
              entry.logos.map((row, key) => {
                return (
                  <div className="Project-logos-row" key={key}>
                    <div className="Project-logo-group">
                      {row.map((logo, index) => {
                        return (
                          <div className="Project-logo" key={index}>
                            <img src={logo} alt="" />
                          </div>
                        );
                      })}
                    </div>
                    <div className="Project-logo-group">
                      {row.map((logo, index) => {
                        return (
                          <div className="Project-logo" key={index}>
                            <img src={logo} alt="" />
                          </div>
                        );
                      })}
                    </div>
                    <div className="Project-logo-group">
                      {row.map((logo, index) => {
                        return (
                          <div className="Project-logo" key={index}>
                            <img src={logo} alt="" />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="Project-sections">
            {entry.sections &&
              entry.sections.map((section, key) => {
                return (
                  <div className="Project-section" key={key}>
                    <h2>{section.title}</h2>
                    <div>
                      {section.text && (
                        <Content modifier="information" html={section.text} />
                      )}
                      {section.column1 && (
                        <div className="Project-section-columns">
                          <div>
                            <Content
                              modifier="information"
                              html={section.column1}
                              className="Project-section-column"
                            />
                          </div>
                          <div>
                            <Content
                              modifier="information"
                              html={section.column2}
                              className="Project-section-column"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="Project-new-footer">
            <NewFooter entry={landing} />
          </div>
          {/* <div className="Project-contact">
            <div className="Project-phone">
              <Content modifier="information" html={entry.phoneNumber} />
            </div>
            <div className="Project-address">
              <Content modifier="information" html={entry.address} />
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Information),
);



// WEBPACK FOOTER //
// ./src/js/templates/information.js